﻿
// WEBPACK ENTRY POINT
// JAVASCRIPT ENTRY POINT

import $ from 'expose-loader?jQuery!jquery';

window.jQuery = $;
window.$ = $;


import 'bootstrap';
import '../../../node_modules/signalr/jquery.signalR.js';
import Vue from 'vue';
import moment from 'moment';
//import '../libs/daterangepicker/daterangepicker.js';
import VeeValidate from 'vee-validate';

//// IMPORT CSS (LEGACY, SHOULD BE DEPRECATED)
import '../../Content/assets/animate.min.css';
import '../../Content/assets/glyphicons/glyphicons.css';
import '../../Content/assets/font-awesome/css/font-awesome.min.css';
import '../../Content/assets/material-design-icons/material-design-icons.css';
import '../../Content/assets/bootstrap/dist/css/bootstrap.min.css';
import '../../Content/assets/daterangepicker.css';
import '../../Content/assets/styles/app.css';
import '../../Content/assets/styles/font.css';

//import '../../Content/Site.css';

import './assets/global.scss';

// Set globals for old scripts
window.moment = moment;
Vue.use(VeeValidate);

// some places have Vue inline instead of in a script
window.Vue = Vue;

import app from '../custom/app';
window.app = $.extend(window.app, app);

import '../custom/script.js';
import '../custom/primatech.generic-crud.js';



// import new custom javascript modules
import './modules/active-vehicles-map/active-vehicles-map.js';
//import apiTest from './modules/api-tests/api-tests.js';
//import './modules/file-explorer/file-explorer.js';
import search from './modules/search/search.js';

import searchBar from './modules/search-bar/search-bar.js';
//import './modules/job-chat/job-chat.js';

import popupReferenceField from './modules/popup-reference-field/popup-reference-field.js';
import popupReferenceKatastarField from './modules/popup-reference-katastar-field/popup-reference-katastar-field.js';
import popupReferenceDatumGenerisanja from './modules/popup-reference-datum-generisanja/popup-reference-datum-generisanja.js';

import popupReferenceObveznik from './modules/popup-reference-obveznik/popup-reference-obveznik.js';
import popupReferencePdo from './modules/popup-reference-pdo/popup-reference-pdo.js';
import popupReferenceZemljiste from './modules/popup-reference-zemljiste/popup-reference-zemljiste.js';

import { componentInitialize } from './modules/utils.js';

var components = [popupReferenceField, popupReferenceKatastarField, popupReferenceDatumGenerisanja, popupReferenceObveznik, popupReferencePdo, popupReferenceZemljiste, search, searchBar];
componentInitialize(components);
